import { fromJS } from 'immutable';

const initialState = fromJS({
});

export default function settings(state = initialState, action = {}) {
  return state;
}
